import styled from "styled-components";

export default function DenyOrderBlock({ children }) {
  return (
    <Block>{children}</Block>
  )
}

const Block = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  padding: 0 calc(100vw * (17 / 375));
  /* padding-top: calc(100vw * (11 / 375)); */
`;